import RequestAbstract from "./RequestAbstract";

export default class UserTeam extends RequestAbstract {
    get link() {
        return this.links.userTeam;
    }
}
